/**
 * Uses the `vio-flutter` on the `window.navigator.userAgent` to determine if user is navigating in the mobile app.
 * @returns A boolean indicating if the user is navigating in the mobile app
 */
export const isFlutterMobileAppUserAgent = (): boolean => {
  return Boolean(window?.navigator?.userAgent?.includes('vio-flutter'))
}
